"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var selectors_1 = require("../../../../../contexts/rubyJackpot/selectors");
var useMoneyFormatter_1 = require("../../../../../hooks/useMoneyFormatter");
var WinnerAnnouncement_1 = __importDefault(require("./WinnerAnnouncement"));
var DURATION = 5000;
var WonPrize = function (_a) {
    var type = _a.type, currency = _a.currency, amount = _a.amount;
    var statistics = (0, selectors_1.usePoolStatistic)(type);
    var _b = (0, react_1.useState)(0), phase = _b[0], setPhase = _b[1];
    var _c = (0, react_1.useState)(false), winnerAnnounced = _c[0], setWinnerAnnounced = _c[1];
    var moneyFormat = (0, useMoneyFormatter_1.useMoneyFormatter)().moneyFormat;
    var _d = (0, react_1.useState)({
        currency: "",
        username: "",
        winAmountCurrency: 0,
    }), newWinner = _d[0], setNewWinner = _d[1];
    var showText = function (phase, stats, type) {
        switch (phase) {
            case 0:
                return "Jackpotul precedent: \n\r ".concat(moneyFormat(amount, currency));
            case 1:
                return "";
            case 2:
                return "Total jackpoturi date: \n\r ".concat(moneyFormat(stats.totalWinCount));
            case 3:
                return "";
            case 4:
                return "Total platit: \n\r ".concat(moneyFormat(stats.totalWinAmount, currency));
            case 5:
                return "";
            case 6:
                return "Castigatori unici: \n\r ".concat(moneyFormat(stats.totalUniqueWinners));
            default:
                return "";
        }
    };
    var setData = function (message) {
        var data = JSON.parse(message.data);
        if (data.type === "jackpot" && data.payload) {
            var jackpotWinners = data.payload.jackpotWinners;
            setWinnerAnnounced(true);
            setNewWinner(jackpotWinners[0]);
            // setStats(data.payload);
        }
    };
    (0, react_1.useEffect)(function () {
        var textChanging = setInterval(function () {
            setPhase((function (prevState) { return prevState + 1; }));
        }, DURATION);
        return function () {
            clearInterval(textChanging);
            textChanging = null;
        };
    }, []);
    // useEffect(() => {
    //   socket.addEventListener("message", setData);
    //   return () => socket.removeEventListener("message", setData);
    // });
    (0, react_1.useEffect)(function () {
        if (winnerAnnounced) {
            var timeout_1 = setTimeout(function () {
                setWinnerAnnounced(false);
            }, 10000);
            return function () {
                clearTimeout(timeout_1);
                timeout_1 = null;
            };
        }
    }, [winnerAnnounced]);
    (0, react_1.useEffect)(function () {
        if (phase >= 8) {
            setPhase(0);
        }
    }, [phase]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "won-prize" }, { children: [!winnerAnnounced && statistics && (0, jsx_runtime_1.jsx)("span", { children: showText(phase, statistics, type) }), winnerAnnounced && (0, jsx_runtime_1.jsx)(WinnerAnnouncement_1.default, { winner: newWinner })] })));
};
var updateCallback = function (prevProps, nextProps) {
    return prevProps.amount === nextProps.amount;
};
exports.default = react_1.default.memo(WonPrize, updateCallback);
